<div class="resend-container">
    <div class="resend-card">
        <div class="resend-header">
            <h1>Renvoyer l'Email de Vérification</h1>
            <p>Entrez votre adresse email pour recevoir un nouveau lien de vérification</p>
        </div>

        <form class="resend-form" [formGroup]="resendForm" (ngSubmit)="onSubmit()">

            <!-- Email Field -->
            <div class="form-group">
                <label for="email">Adresse Email *</label>
                <input type="email" id="email" formControlName="email" [class.error]="hasError('email')" placeholder="Entrez votre adresse email" autocomplete="email">
                <div *ngIf="hasError('email')" class="error-message">
                    {{ getFieldError('email') }}
                </div>
            </div>

            <!-- Error Message -->
            <div *ngIf="errorMessage && !isSuccess" class="alert alert-error">
                {{ errorMessage }}
            </div>

            <!-- Success Message -->
            <div *ngIf="isSuccess" class="alert alert-success">
                <h3>✅ Succès!</h3>
                <p>{{ successMessage }}</p>
                <p class="redirect-info">Redirection automatique vers la page de connexion dans 5 secondes...</p>
            </div>

            <!-- Submit Button -->
            <button type="submit" class="resend-btn" [disabled]="isLoading || resendForm.invalid" [class.loading]="isLoading">
        <span *ngIf="!isLoading">Renvoyer le lien de vérification</span>
        <span *ngIf="isLoading">Envoi en cours...</span>
      </button>

            <!-- Links -->
            <div class="resend-links">
                <p>
                    <a [routerLink]="['/login']" class="link">Retour à la connexion</a>
                </p>
                <p>
                    Pas encore de compte? <a [routerLink]="['/register']" class="link">Créer un compte</a>
                </p>
            </div>
        </form>
    </div>
</div>